import { render, staticRenderFns } from "./ModalCodigo.vue?vue&type=template&id=974e70da"
import script from "./ModalCodigo.vue?vue&type=script&lang=js"
export * from "./ModalCodigo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports